import { render, staticRenderFns } from "./etranslate-component.vue?vue&type=template&id=32d1d740&scoped=true&"
import script from "./etranslate-component.vue?vue&type=script&lang=ts&"
export * from "./etranslate-component.vue?vue&type=script&lang=ts&"
import style0 from "./etranslate-component.vue?vue&type=style&index=0&id=32d1d740&scoped=true&lang=scss&"
import style1 from "./etranslate-component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1d740",
  null
  
)

export default component.exports